import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { SpecialistFormData } from '../../types/specialistPageTypings';
import { specialistFunnelsPagesFactory } from '../../utils/specialistFunnelsPagesFactory';

export function useTryToRequestCreatingSpecialistFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async (payload: SpecialistFormData) => {
      const body = specialistFunnelsPagesFactory(payload);

      return await apiCancellationFunnels.tryToRequestCreatingSpecialistFunnelPage(
        body
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao criar o funil de Atendimento Especialista',
        'Ocorreu um erro ao criar o funil de Atendimento Especialista, por favor tente novamente mais tarde.'
      );
    },
  });

  return { tryToRequestCreatingSpecialistFunnelPage: mutateAsync, isLoading };
}
